module.exports = __webpack_public_path__ + "static/pr-op-management@3x-67e45f337dec71a345e9f128ee71aa6c.png";